import React from 'react';
import { sanitize } from 'dompurify';

const XssHTMLSanitizer = ({ targetComponent: Component, htmlData, ...props }) => {
    return <Component {...props} dangerouslySetInnerHTML={{ __html: sanitize(htmlData) }} />;
};

export default XssHTMLSanitizer;
